export default class AnalyticsService {
    initialize() { }
    identify(userId) { }
    track(eventName, properties) { }
    trackPage(url) { }
}
